import React, { useState, useRef, useEffect } from 'react';
import { Search, X, Check } from 'lucide-react';

const ItemSelect = ({ items, selectedItem, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const filteredItems = items.filter(item =>
    item.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleSelect = (itemId) => {
    onChange(itemId);
    setIsOpen(false);
  };

  const getSelectedItemName = () => {
    const item = items.find(i => i._id === selectedItem);
    return item ? item.name : '';
  };

  return (
    <div className="relative" ref={dropdownRef}>
      <label className="block text-xs font-medium text-gray-700">Item *</label>
      <div
        className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm bg-white"
        onClick={() => setIsOpen(!isOpen)}
      >
        <div className="h-[2.5rem] px-3 flex items-center justify-between cursor-pointer">
          {/* This height matches the default Tailwind input height */}
          {selectedItem ? (
            <span className="text-sm text-gray-900 truncate">{getSelectedItemName()}</span>
          ) : (
            <span className="text-sm text-gray-500">Select item...</span>
          )}
          {selectedItem && (
            <button
              onClick={(e) => {
                e.stopPropagation();
                onChange('');
              }}
              className="text-gray-400 hover:text-gray-500"
            >
              <X className="h-4 w-4" />
            </button>
          )}
        </div>
      </div>

      {isOpen && (
        <div className="absolute z-20 mt-1 w-full bg-white border rounded-md shadow-lg">
          <div className="p-2 border-b">
            <div className="relative">
              <Search className="absolute left-2 top-2.5 h-4 w-4 text-gray-400" />
              <input
                type="text"
                className="pl-8 pr-4 py-2 w-full border rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Search items..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                onClick={(e) => e.stopPropagation()}
              />
            </div>
          </div>

          <div className="max-h-60 overflow-y-auto">
            {filteredItems.length > 0 ? (
              filteredItems.map((item) => (
                <div
                  key={item._id}
                  className="flex items-center px-4 py-2 hover:bg-gray-50 cursor-pointer"
                  onClick={() => handleSelect(item._id)}
                >
                  <div className="flex items-center flex-1">
                    <div className="w-4 h-4 border rounded mr-3 flex items-center justify-center">
                      {selectedItem === item._id && (
                        <Check className="h-3 w-3 text-blue-600" />
                      )}
                    </div>
                    <div>
                      <span className="text-sm font-medium text-gray-900">{item.name}</span>
                      <p className="text-xs text-gray-500">{item.amountType}</p>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="px-4 py-2 text-sm text-gray-500">
                No items found
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default ItemSelect;